import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem } from "reactstrap";

const BreadcrumbWithLink = props => {
  const { title, breadcrumbItems } = props;

  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-0 font-size-18">{title}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {breadcrumbItems.map((item, index) => {
                return (
                  <BreadcrumbItem key={index}>
                    <Link to={item.link || "#"}>{item.name}</Link>
                  </BreadcrumbItem>
                );
              })}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

BreadcrumbWithLink.propTypes = {
  title: PropTypes.string,
  breadcrumbItems: PropTypes.array,
};

BreadcrumbWithLink.defaultProps = {
  breadcrumbItems: [],
  title: "",
};

export default BreadcrumbWithLink;
